import { fetchLatestPaperFinderState } from '@/store/thunks/FetchPaperFinder';
import {
  PaperFinderWidgetData,
  PaperFinderWidgetDataWithThread,
} from '@/models/PaperFinder';
import { ThreadId } from '@/models/Thread';

import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface PaperFinderWidgetState {
  stateForThreads: Record<ThreadId, PaperFinderWidgetData>;
}

const initialState: PaperFinderWidgetState = { stateForThreads: {} };

const setActiveWidgetDataForThreadReducer = (
  state: PaperFinderWidgetState,
  action: PayloadAction<PaperFinderWidgetDataWithThread>,
) => {
  const { threadId, data } = action.payload;
  state.stateForThreads[threadId] = data;
};

export const paperFinderWidgetSlice = createSlice({
  name: 'paperFinderWidgetStore',
  initialState,
  reducers: {
    setActiveWidgetDataForThread: setActiveWidgetDataForThreadReducer,
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchLatestPaperFinderState.fulfilled,
      setActiveWidgetDataForThreadReducer,
    );
  },
  selectors: {
    getActiveWidgetDataForThread(
      state: PaperFinderWidgetState,
      threadId?: ThreadId,
    ) {
      if (threadId !== undefined) {
        return state.stateForThreads[threadId];
      } else {
        return undefined;
      }
    },
  },
});

export const { setActiveWidgetDataForThread } = paperFinderWidgetSlice.actions;
export const { getActiveWidgetDataForThread } =
  paperFinderWidgetSlice.selectors;
